// extracted by mini-css-extract-plugin
module.exports = {"header":"WorkspacesBox_header__3l6fm","box":"WorkspacesBox_box__9J7xU","node":"WorkspacesBox_node__1L0oH"};